// extracted by mini-css-extract-plugin
export default {"drawerLayout":"MenuDrawer_drawerLayout__YZRD6","gallery":"MenuDrawer_gallery__uyQuv"};